import { Component, OnDestroy, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import * as moment from "moment";
import { Subscription } from "rxjs/Subscription";
import { EventArticle } from "../../models/event-article";
import { User } from "../../models/user";
import { EventArticleService } from "../../services/event-article.service";
import { SidenavService } from "../../services/sidenav.service";
import { EventArticlesActions } from "../../store/actions/event-articles.actions";

@Component({
  selector: "app-event-article",
  templateUrl: "./event-article.component.html",
  styleUrls: ["./event-article.component.scss"],
})
export class EventArticleComponent implements OnInit, OnDestroy {
  currentUser: User;

  sportingEvents: EventArticle[];
  sportingEventsFiltered: EventArticle[];

  term: string;
  currentEvents: boolean;
  contribued: boolean;

  loading: boolean;
  subscriptions: Subscription[];

  formats: any[] = [
    "16:9",
    "4:3",
    "3:4",
    "140:303",
    "10:3",
    "1:1",
    "2:3",
    "485:173",
  ];

  constructor(
    private eventArticleService: EventArticleService,
    private eventArticlesActions: EventArticlesActions,
    private store: Store<any>,
    private router: Router,
    private title: Title,
    private sidenavService: SidenavService
  ) {
    this.subscriptions = [];
    this.title.setTitle("Taiga - Event Article");
    this.sidenavService.currentTab = "Event Article";
    this.sportingEvents = [];
    this.sportingEventsFiltered = [];
    this.contribued = null;
    this.term = "";
    this.currentEvents = false;

    this.subscriptions.push(
      this.store
        .select("eventArticlesState")
        .subscribe((sportingEvents: any) => {
          this.sportingEvents = sportingEvents;
          this.refresh();
        })
    );
  }

  ngOnInit() {
    this.loading = true;
    this.load();
  }

  load() {
    this.store.select("userState").subscribe((user: User) => {
      if (user) {
        this.currentUser = user;
        this.eventArticleService
          .GetMasterSportingEvents(user.currentLanguage.id)
          .subscribe((sportingEvents) => {
            this.eventArticlesActions.setEventArticles(sportingEvents);
            this.sportingEvents = sportingEvents;
            this.refresh();
            this.loading = false;
          });
      }
    });
  }

  refresh() {
    // Initiliaze list to filter
    let sportingEvents = this.sportingEvents;

    // Filter by date
    if (this.currentEvents) {
      sportingEvents = sportingEvents.filter((sportingEvent) =>
        moment().isBetween(
          moment(sportingEvent.startDate, "DD/MM/YYYY"),
          moment(sportingEvent.endDate, "DD/MM/YYYY").add(1, "days")
        )
      );
    }

    // Filter by contribution
    if (this.contribued === null) {
      sportingEvents = sportingEvents;
    } else if (this.contribued === true) {
      sportingEvents = sportingEvents.filter(
        (sportingEvent) => sportingEvent.isContribued
      );
    } else {
      sportingEvents = sportingEvents.filter(
        (sportingEvent) => !sportingEvent.isContribued
      );
    }

    // Filter by term
    if (this.term !== "") {
      sportingEvents = sportingEvents.filter(
        (sportingEvent) =>
          sportingEvent.id.toString().includes(this.term) ||
          sportingEvent.name.toLowerCase().includes(this.term.toLowerCase())
      );
    }

    // Set result
    this.sportingEventsFiltered = sportingEvents;
  }

  /**
   * Set the contribued value and filter the sportingEvents
   * @param value : contribued value
   */
  setContribued(value: boolean) {
    this.contribued = value;
    this.refresh();
  }

  /**
   * Only get current events or not
   * @param event
   */
  changeCurrentEvents(event) {
    this.currentEvents = event.checked;
    this.refresh();
  }

  /**
   * Clear the filters
   */
  searchClear() {
    this.term = "";
    this.contribued = null;
    this.currentEvents = false;
    this.refresh();
  }

  /**
   * Open the edit picture modal
   */
  editPicture(eventArticle: EventArticle) {
    this.router.navigate(
      [
        {
          outlets: {
            modal: [
              "edit",
              "picture",
              eventArticle.id,
              0,
              "Original",
              "event-article",
            ],
          },
        },
      ],
      {
        queryParams: {
          format: this.formats,
        },
      }
    );
  }

  /**
   * Open the modal that shows all the additional pictures
   * 
   */
  seeAdditionalPictures(eventArticle: EventArticle) {
    this.router.navigate([
      {
        outlets: {
          modal: [
            "view",
            "event-additional",
            eventArticle.id,
            this.currentUser.currentLanguage.id,
          ],
        },
      },
    ]);
  }

  openMultilingual(eventArticle: EventArticle) {
    this.router.navigate([
      {
        outlets: {
          modal: ["edit", "multilingual-event-article", eventArticle.id],
        },
      },
    ]);
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./src/app/pages/event-article/event-article.component.ts